module.exports = __webpack_public_path__ + "static/media/contributor-ic.3b7ce09b.svg";